import { SearchOutlined } from '@ant-design/icons';
export const FORM_CUSTOMER_DATA = () => {
  return [
    {
      name: 'telephone',
      type: 'INPUT_PHONE',
      placeholder: '',
      label: 'เบอร์ติดต่อ (กรอกเบอร์ติดต่อแล้วกด Enter)',
      disabled: true,
      rules: {
        required: true,
        pattern: /^[0-9]{10}$/,
      },
      maxLength: 10,
    },
    {
      name: 'fullName',
      type: 'INPUT',
      disabled: true,
      placeholder: '',
      label: 'ชื่อ - นามสกุล',
      rules: {
        required: true,
      },
    },
    {
      name: 'createDate',
      label: 'วันที่เริ่มรับประกัน',
      type: 'DATE_PICKER',
      placeholder: '',
      format: 'YYYY-MM-DD',
      disabled: true,
    },
    {
      name: 'expireDate',
      label: 'วันหมดอายุ',
      type: 'DATE_PICKER',
      format: 'YYYY-MM-DD',
      placeholder: '',
      disabled: true,
    },
  ];
};

export const FORM_PRODUCT_DATA = ({ mobileBrandList, channelBuyList, onEnter, onEnterWarrantyCode , getValues }) => {
  // ถ้าบาร์โค้ดกับรหัสรับประกันไม่ตรงกัน จะ enable search button
  const barcode = getValues('barcode');
  const warrantyNumberCode = getValues('warrantyNumberCode');
  const isWarrantyCodeEnabled = warrantyNumberCode !== barcode;
  const accept = ['image/jpeg', 'image/png', 'image/jpg', 'image/bmp'];
  return [
    {
      name: 'barcodeShortcut',
      type: 'INPUT_BARCODE',
      placeholder: '',
      label: 'Barcode',
      rules: {
        required: true,
        pattern: /^[0-9]{9}$/,
      },
      maxLength: 9,
      onEnter,
    },
    {
      name: 'warrantyNumberCode',
      type: 'INPUT',
      placeholder: '',
      label: 'รหัสรับประกัน',
      disabled: !isWarrantyCodeEnabled,
      addonAfter: (value) => (
        <SearchOutlined
          style={{ cursor: 'pointer', color: 'gray' }}
          onClick={() => onEnterWarrantyCode(value)}
        />
      ), 
      rules: {
        required: true,
      },
      onEnter: onEnterWarrantyCode,
    },
    {
      name: 'productId',
      type: 'HIDDEN',
    },
    {
      name: 'productName',
      type: 'INPUT',
      placeholder: '',
      disabled: true,
      label: 'ชื่อสินค้า',
      rules: {
        required: true,
      },
    },
    {
      name: 'productTypeName',
      type: 'INPUT',
      placeholder: '',
      disabled: true,
      label: 'ประเภทของสินค้า',
      rules: {
        required: true,
      },
    },
    {
      name: 'mobileBrandId',
      type: 'DROPDOWN',
      placeholder: '',
      label: 'ยี่ห้อ',
      properties: {
        options: mobileBrandList || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'mobileModelName',
      type: 'INPUT',
      placeholder: '',
      label: 'รุ่น',
      rules: {
        required: true,
      },
    },
    {
      name: 'channelBuyId',
      type: 'DROPDOWN',
      placeholder: '',
      label: 'ช่องทางการซื้อขาย',
      properties: {
        options: channelBuyList || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'purchaseDate',
      type: 'DATE_PICKER',
      placeholder: '',
      label: 'วันที่ซื้อสินค้า',
      format: 'YYYY-MM-DD',
    },
    {
      name: 'pictureInfo',
      type: 'TEXT',
      placeholder: '',
      label: 'ชนิดรูปภาพที่ต้องการ (.png, .jpg, .jpeg, .bmp)',
    },
    {
      name: 'invImageUrl',
      type: 'UPLOAD',
      label: 'รูปใบเสร็จ',
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      accept: accept.join(','),
      rules: {
        required: true,
      },
    },
    {
      name: 'packageImageUrl',
      type: 'UPLOAD',
      label: 'รูปสินค้า',
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      accept: accept.join(','),
      rules: {
        required: true,
      },
    },
  ];
};
export const FORM_EDIT_EXPIRED = () => {
  const span = 24;
  return [
    {
      name: 'warrantyId',
      type: 'HIDDEN',
    },
    {
      name: 'expireDate',
      label: 'วันหมดอายุ',
      type: 'DATE_PICKER',
      format: 'YYYY-MM-DD',
      placeholder: '',
      span,
      rules: {
        required: true,
      },
    },
    {
      name: 'remark',
      label: 'หมายเหตุ (ระบุได้ไม่เกิน 500 ตัวอักษร)',
      type: 'INPUT_AREA',
      placeholder: '',
      rules: {
        required: true,
        maxLength: 500,
      },
      span,
    },
  ];
};
